var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('WhitePapersPage', {
    attrs: {
      "paperTitle": 'White Papers',
      "whitePaperItems": _vm.items,
      "isRecentPapers": true
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }